const educ2Overview = [
  {
      "country": "Switzerland",
      "total": 85,
      "project": 100,
      "career": 95,
      "employ": 94,
      "edu": 72,
      "econ": 75,
      "liva": 75,
      "im": "im"
  },
  {
      "country": "USA",
      "total": 82,
      "project": 93,
      "career": 86,
      "employ": 94,
      "edu": 74,
      "econ": 74,
      "liva": 68,
      "im": "im"
  },
  {
      "country": "Singapore",
      "total": 79,
      "project": 100,
      "career": 66,
      "employ": 97,
      "edu": 55,
      "econ": 92,
      "liva": 65,
      "im": "im"
  },
  {
      "country": "Australia",
      "total": 75,
      "project": 66,
      "career": 79,
      "employ": 84,
      "edu": 73,
      "econ": 74,
      "liva": 74,
      "im": "im"
  },
  {
      "country": "Canada",
      "total": 74,
      "project": 67,
      "career": 79,
      "employ": 84,
      "edu": 71,
      "econ": 73,
      "liva": 72,
      "im": "im"
  },
  {
      "country": "UK",
      "total": 73,
      "project": 59,
      "career": 85,
      "employ": 72,
      "edu": 79,
      "econ": 75,
      "liva": 68,
      "im": "im"
  },
  {
      "country": "Austria",
      "total": 64,
      "project": 65,
      "career": 56,
      "employ": 69,
      "edu": 51,
      "econ": 75,
      "liva": 68,
      "im": "im"
  },
  {
      "country": "Hong Kong",
      "total": 64,
      "project": 76,
      "career": 70,
      "employ": 86,
      "edu": 49,
      "econ": 50,
      "liva": 51,
      "im": "im"
  },
  {
      "country": "Spain",
      "total": 63,
      "project": 47,
      "career": 60,
      "employ": 63,
      "edu": 53,
      "econ": 93,
      "liva": 60,
      "im": "im"
  },
  {
      "country": "UAE",
      "total": 63,
      "project": 77,
      "career": 44,
      "employ": 83,
      "edu": 49,
      "econ": 67,
      "liva": 55,
      "im": "im"
  },
  {
      "country": "Italy",
      "total": 62,
      "project": 50,
      "career": 61,
      "employ": 58,
      "edu": 51,
      "econ": 93,
      "liva": 58,
      "im": "im"
  },
  {
      "country": "New Zealand",
      "total": 59,
      "project": 60,
      "career": 40,
      "employ": 56,
      "edu": 55,
      "econ": 75,
      "liva": 67,
      "im": "im"
  },
  {
      "country": "Malta",
      "total": 55,
      "project": 43,
      "career": 54,
      "employ": 68,
      "edu": 34,
      "econ": 75,
      "liva": 55,
      "im": "im"
  },
  {
      "country": "Portugal",
      "total": 52,
      "project": 46,
      "career": 42,
      "employ": 47,
      "edu": 43,
      "econ": 74,
      "liva": 61,
      "im": "im"
  },
  {
      "country": "Greece",
      "total": 49,
      "project": 40,
      "career": 37,
      "employ": 46,
      "edu": 43,
      "econ": 74,
      "liva": 52,
      "im": "im"
  },
  {
      "country": "Malaysia",
      "total": 43,
      "project": 27,
      "career": 38,
      "employ": 47,
      "edu": 37,
      "econ": 64,
      "liva": 46,
      "im": ""
  },
  {
      "country": "China",
      "total": 42,
      "project": 37,
      "career": 53,
      "employ": 39,
      "edu": 48,
      "econ": 26,
      "liva": 47,
      "im": ""
  },
  {
      "country": "Thailand",
      "total": 34,
      "project": 39,
      "career": 21,
      "employ": 41,
      "edu": 34,
      "econ": 21,
      "liva": 45,
      "im": ""
  },
  {
      "country": "India",
      "total": 32,
      "project": 30,
      "career": 43,
      "employ": 31,
      "edu": 42,
      "econ": 8,
      "liva": 39,
      "im": ""
  },
  {
      "country": "South Africa",
      "total": 30,
      "project": 41,
      "career": 30,
      "employ": 25,
      "edu": 29,
      "econ": 17,
      "liva": 40,
      "im": ""
  },
  {
      "country": "Türkiye",
      "total": 30,
      "project": 22,
      "career": 22,
      "employ": 31,
      "edu": 42,
      "econ": 23,
      "liva": 39,
      "im": ""
  },
  {
      "country": "Indonesia",
      "total": 25,
      "project": 23,
      "career": 16,
      "employ": 29,
      "edu": 29,
      "econ": 15,
      "liva": 41,
      "im": ""
  },
  {
      "country": "Vietnam",
      "total": 24,
      "project": 29,
      "career": 14,
      "employ": 26,
      "edu": 26,
      "econ": 6,
      "liva": 41,
      "im": ""
  },
  {
      "country": "Philippines",
      "total": 23,
      "project": 33,
      "career": 16,
      "employ": 17,
      "edu": 25,
      "econ": 10,
      "liva": 38,
      "im": ""
  },
  {
      "country": "Egypt",
      "total": 22,
      "project": 24,
      "career": 14,
      "employ": 24,
      "edu": 33,
      "econ": 4,
      "liva": 34,
      "im": ""
  },
  {
      "country": "Pakistan",
      "total": 16,
      "project": 22,
      "career": 9,
      "employ": 12,
      "edu": 22,
      "econ": 1,
      "liva": 27,
      "im": ""
  },
  {
      "country": "Nigeria",
      "total": 14,
      "project": 22,
      "career": 9,
      "employ": 10,
      "edu": 12,
      "econ": 2,
      "liva": 28
  }
];

export {educ2Overview};